import React from 'react';
import PropTypes from 'prop-types';
import { nike } from '@nike/nike-design-tokens';
import { Check } from '@nike/nike-design-system-icons';
import { TextStyled } from '@nike/nike-design-system-components';
import { StepContext } from '../StepContext';

const { podiumCdsColorGrey500, podiumCdsColorTextPrimary, podiumCdsColorWhite } = nike;

export const StepLabel = ({ children, classes = {}, components = {}, ...props }) => {
  const { activeStep, stepIndex } = React.useContext(StepContext);
  const active = activeStep === stepIndex;
  const completed = activeStep > stepIndex;
  const completedOrActive = completed || active;

  // assign default components
  const StepLabelComp = components.StepLabelComp ?? TextStyled;
  const StepIcon = components.StepIconComp ?? 'i';

  return (
    <>
      <StepIcon completedOrActive={completedOrActive} className={classes.stepIcon}>
        <TextStyled
          appearance={completed ? 'body3Strong' : 'body3'}
          color={completedOrActive ? podiumCdsColorWhite : podiumCdsColorGrey500}
        >
          {completed ? <Check /> : String(Number(stepIndex) + 1)}
        </TextStyled>
      </StepIcon>
      <StepLabelComp
        className={classes.stepLabel}
        appearance='body3'
        color={completedOrActive ? podiumCdsColorTextPrimary : podiumCdsColorGrey500}
        {...props}
      >
        {children}
      </StepLabelComp>
    </>
  );
};

StepLabel.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired
};
